/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-console */
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useState, MouseEvent, useContext, useMemo, useCallback } from 'react';
import { IoMdMore } from 'react-icons/io';
import { updateCategory } from '../../../../../../../../actions/resource_configuration';
import { toast } from 'react-toastify';
import CategoryDeletePopup from './DeletePopup';
import { deleteArticle, publishArticle } from '../../../../../../../../actions/article_management/article_management';
import { deleteVideo, updateVideoStatus } from '../../../../../../../../actions/video_management/video_management';
import { deleteImage, updateImageStatus, getImageCollections } from '../../../../../../../../actions/image_management/image_management';
import { deleteDocumentCollection, updateDocumentStatus, getDocumentCollections } from '../../../../../../../../actions/document_management/document_management';
import { deletePlaylist, updatePlaylist } from '../../../../../../../../actions/playlist_management';
import { API } from '@aws-amplify/api';
import { useSelector } from 'react-redux';
import { updatePodcastStatus, updatePodcastSeasonStatus, updatePodcastSeasonEpisodeStatus } from '../../../../../../../../actions/podcast_management';
import { getVideosList } from '../../../../../../../../actions/video_management';
import { handleVideoUpdate } from '../../../Creation/Video/VideoUploadHelper';
import useContentPermissions from '../../../Reusable/ContentCards/useContentPermissions';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import useResourceHelper from '../../../Reusable/ContentCards/useResourceHelper';

interface EditContentProps {
	handlePreview: (event: MouseEvent<HTMLElement>) => void;
	handleEditContent?: (event: MouseEvent<HTMLElement>) => void;
	handlemOpenplaylisttoSlider?: (event: MouseEvent<HTMLElement>) => void;
	handlemOpenMovetoSlider?: (event: MouseEvent<HTMLElement>) => void;
	ContentCategoryType?: boolean;
	type?: string;
	contentStatus?: 'draft' | 'published' | 'unpublished' | 'scheduled' | 'enabled' | 'disabled';
	ContentView?: any;
	contentData?: any;
	setCategoryData?: (data: any) => void;
	onDeleteSuccess?: () => void;
	fromType?: string;
	handleCopyLink: (event: MouseEvent<HTMLElement>) => void;
	StatusTxtMsg?: any;
}

export const EditContent = ({
	handlePreview,
	handleEditContent = () => {},
	handlemOpenplaylisttoSlider,
	handlemOpenMovetoSlider,
	ContentCategoryType,
	type,
	setCategoryData,
	onDeleteSuccess,
	contentData,
	fromType,
	handleCopyLink,
	contentStatus
}: EditContentProps) =>
{
	const [ showDeleteConfirm, setShowDeleteConfirm ] = useState(false);
	const [ isDeleting, setIsDeleting ] = useState(false);
	const [ isConfirmed, setIsConfirmed ] = useState(false);
	const [ isPublishing, setIsPublishing ] = useState(false);
	const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);
	const {
		hasPublishPermission,
		hasEditPermission,
		isArticlesEnabled,
		isImagesEnabled,
		isVideosEnabled,
		isDocumentsEnabled,
		isPodcastsEnabled,
		isPlaylistsEnabled
	} = useContentPermissions();
	const { language } = useContext(LanguageContext);
	const { isAdminView } = useResourceHelper();

	// Helper function to check if the current content type is enabled
	const isContentTypeEnabled = useCallback(() =>
	{
		switch (type)
		{
			case 'Articles':
				return isArticlesEnabled;
			case 'Videos':
				return isVideosEnabled;
			case 'Images':
				return isImagesEnabled;
			case 'Documents':
				return isDocumentsEnabled;
			case 'Podcasts':
				return isPodcastsEnabled;
			case 'Playlists':
				return isPlaylistsEnabled;
			default:
				return true; // Default to enabled for unknown types
		}
	}, [ type, isArticlesEnabled, isVideosEnabled, isImagesEnabled, isDocumentsEnabled, isPodcastsEnabled, isPlaylistsEnabled ]);

	// Helper function to check if user has write permissions (edit/delete)
	const hasWritePermission = useMemo(() =>
	{
		// Check if the specific content type is enabled
		return hasEditPermission && isContentTypeEnabled();
	}, [ hasEditPermission, isContentTypeEnabled ]);

	// Helper function to check if user has publish permissions
	const hasPublishPermissionForType = useMemo(() =>
	{
		// Check if the specific content type is enabled
		return hasPublishPermission && isContentTypeEnabled();
	}, [ hasPublishPermission, isContentTypeEnabled ]);

	const handleMoreClick = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(null);
	};

	const handlePreviewClick = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		handlePreview(event);
		setAnchorEl(null);
	};

	const handleCopyLinkClick = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		handleCopyLink(event);
		setAnchorEl(null);
	};

	const handleEditContentClick = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();

		// Check if user has write permission for this content type
		if (!hasWritePermission)
		{
			toast.error('You do not have permission to edit this content type');

			return;
		}

		handleEditContent(event);
		setAnchorEl(null);
	};

	const handleContentDelete = (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(null);
		setShowDeleteConfirm(true);
	};

	// Determine the current status and appropriate label
	// const getCurrentStatus = () =>
	// {
	// 	return contentData?.status || 'draft';
	// };

	// Handle publish/unpublish for all content types
	const handlePublishUnpublish = async (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(null);

		// Check if user has publish permission for this content type
		if (!hasPublishPermissionForType)
		{
			toast.error('You do not have permission to publish/unpublish this content type');

			return;
		}

		if (!contentData || !contentData._id)
		{
			toast.error('Cannot publish/unpublish: invalid content data');

			return;
		}

		setIsPublishing(true);
		const contentId = contentData._id;
		// const currentStatus = contentStatus;

		// console.log('currentStatus:::::', currentStatus);

		try
		{
			let response;

			// Handle different content types
			switch (type)
			{
				case 'Articles': {
					if (contentStatus === 'published')
					{
						response = await publishArticle(contentId, { status: 'unpublished' });
						toast.success('Article unpublished successfully');
					}
					else
					{
						response = await publishArticle(contentId, { status: 'published' });
						toast.success('Article published successfully');
					}
					if (setCategoryData && response) setCategoryData(response);
					break;
				}

				case 'Videos': {
					// const videoUpdateOptions = {
					// 	videoId     : contentId,
					// 	// visibility  : contentStatus === 'published' ? 'private' as const : 'public' as const,
					// 	status      : contentStatus === 'published' ? 'unpublished' as const : 'published' as const,
					// 	title       : contentData.title,
					// 	description : contentData.description,
					// 	categoryId  : contentData.categoryId,
					// 	tags        : contentData.tags,
					// 	url         : contentData.url,
					// 	fileType    : contentData.fileType,
					// 	fileSize    : contentData.fileSize,
					// 	thumbnail   : contentData.thumbnail,
					// 	playlists   : contentData.playlists,
					// 	sourceType  : 'system' as const
					// };

					// await handleVideoUpdate(contentData.companyId, videoUpdateOptions);
					const status = contentStatus === 'published' ? 'unpublished' : 'published';

					await updateVideoStatus(contentId, status, 0);
					const videoResponse = await getVideosList(contentData.companyId, {
						from : isAdminView ? 'Configuration' : 'MyResource'
					}) as any;

					if (videoResponse?.data && setCategoryData)
					{
						setCategoryData(videoResponse.data);
					}
					toast.success(contentStatus === 'published' ? 'Video unpublished successfully' : 'Video published successfully');
					break;
				}

				case 'Images': {
					const newImageStatus = contentStatus === 'published' ? 'unpublished' : 'published';

					await updateImageStatus(contentId, newImageStatus);
					const imageResponse = await getImageCollections(contentData.companyId);

					if (imageResponse?.data && setCategoryData)
					{
						setCategoryData(imageResponse.data);
					}
					toast.success(contentStatus === 'published' ? 'Image unpublished successfully' : 'Image published successfully');
					break;
				}

				case 'Documents': {
					const newDocumentStatus = contentStatus === 'published' ? 'unpublished' : 'published';

					await updateDocumentStatus(contentId, newDocumentStatus);
					const documentResponse = await getDocumentCollections(contentData.companyId);

					if (documentResponse?.data && setCategoryData)
					{
						setCategoryData(documentResponse.data);
					}
					toast.success(contentStatus === 'published' ? 'Document unpublished successfully' : 'Document published successfully');
					break;
				}

				case 'Podcasts': {
					const viewMode = contentData.viewMode || 'podcasts';

					switch (viewMode)
					{
						case 'podcasts':
							await updatePodcastStatus(contentId, {
								status : contentStatus === 'published' ? 'unpublished' : 'published'
							}, false);
							break;
						case 'seasons':
							if (!contentData.podcastId)
							{
								throw new Error('Podcast ID is required for season publishing');
							}
							await updatePodcastSeasonStatus(contentData.podcastId, contentId, {
								status : contentStatus === 'published' ? 'unpublished' : 'published'
							});
							break;
						case 'episodes':
							if (!contentData.podcastId || !contentData.seasonId)
							{
								throw new Error('Podcast ID and Season ID are required for episode publishing');
							}
							await updatePodcastSeasonEpisodeStatus(
								contentData.podcastId,
								contentId,
								{
									status : contentStatus === 'published' ? 'unpublished' : 'published'
								}
							);
							break;
						default:
							throw new Error('Invalid view mode for podcast publishing');
					}
					toast.success(contentStatus === 'published' ? 'Podcast unpublished successfully' : 'Podcast published successfully');
					break;
				}

				default:
					toast.error(`Unsupported content type: ${type}`);
					break;
			}

			// Call success callback if provided
			if (onDeleteSuccess)
			{
				onDeleteSuccess();
			}

			// Trigger a custom event to refresh the content list
			// This ensures the content moves between sections without page reload
			const refreshEvent = new CustomEvent('contentStatusChanged', {
				detail : {
					contentId,
					newStatus   : contentStatus === 'published' ? 'unpublished' : 'published',
					contentType : type
				}
			});

			window.dispatchEvent(refreshEvent);
		}
		catch (error)
		{
			console.error('Error publishing/unpublishing content:', error);
			const action = contentStatus === 'published' ? 'unpublish' : 'publish';

			toast.error(`Failed to ${action} ${type?.toLowerCase() || 'content'}`);
		}
		finally
		{
			setIsPublishing(false);
		}
	};

	// Handle enable/disable for playlists
	const handleEnableDisable = async (event: MouseEvent<HTMLElement>) =>
	{
		event.stopPropagation();
		setAnchorEl(null);

		if (!contentData || !contentData._id)
		{
			toast.error('Cannot enable/disable: invalid playlist data');

			return;
		}

		try
		{
			const newEnabledState = !contentData.enabled;
			const response = await updatePlaylist(contentData._id, { enabled: newEnabledState });

			console.log('Playlist update successful:', response);

			// Update the content data with the new state
			if (setCategoryData)
			{
				setCategoryData(response);
			}

			// Call success callback if provided
			if (onDeleteSuccess)
			{
				onDeleteSuccess();
			}

			// Trigger a custom event to refresh the content list
			const refreshEvent = new CustomEvent('contentStatusChanged', {
				detail : {
					contentId   : contentData._id,
					newStatus   : newEnabledState ? 'enabled' : 'disabled',
					contentType : 'Playlists'
				}
			});

			window.dispatchEvent(refreshEvent);
		}
		catch (error)
		{
			console.error('Error updating playlist enabled state:', error);
			toast.error('Failed to update playlist status');
		}
	};

	// Handle confirmation checkbox change in delete popup
	const handleConfirmChange = (event: React.ChangeEvent<HTMLInputElement>) =>
	{
		event.stopPropagation();
		setIsConfirmed(event.target.checked);
	};

	// Function to handle content deletion
	const handleDeleteConfirm = async (e?: any) =>
	{
		if (e) e.stopPropagation();

		// Check if user has write permission for this content type
		if (!hasWritePermission)
		{
			toast.error('You do not have permission to delete this content type');
			setShowDeleteConfirm(false);

			return;
		}

		// if (!isConfirmed)
		// {
		// 	toast.error('Please confirm deletion by checking the box');

		// 	return;
		// }

		if (!contentData || !contentData._id)
		{
			toast.error('Cannot delete: invalid content data');
			setShowDeleteConfirm(false);

			return;
		}

		setIsDeleting(true);
		const contentId = contentData._id;

		try
		{
			let response;

			switch (type)
			{
				case 'Articles':
					response = await deleteArticle(contentId);
					break;

				case 'Videos':
					response = await deleteVideo(contentId);
					break;

				case 'Images':
					response = await deleteImage(contentId);
					break;

				case 'Documents':
					response = await deleteDocumentCollection(contentId);
					break;

				case 'Podcasts':
					// Based on API patterns in the codebase, this should be the format
					response = await API.del('resourceManagementVPP', `/podcasts/${contentId}`, {});
					break;

				case 'Playlists':
					response = await deletePlaylist(contentId);
					break;

				default:
					toast.error(`Unsupported content type: ${type}`);
					setIsDeleting(false);
					setShowDeleteConfirm(false);

					return;
			}

			console.log(`${type} deletion response*****:`, response);

			toast.success(`${type?.slice(0, -1) || 'Content'} deleted successfully`);

			// Close the dialog first
			setShowDeleteConfirm(false);

			// Immediately call the callback to update the content list
			if (onDeleteSuccess)
			{
				onDeleteSuccess();
			}

			// If we have setCategoryData, update it to force refresh
			if (setCategoryData)
			{
				setCategoryData(null);
			}

			// Trigger a custom event to refresh the content list
			// This ensures the content is removed from the list immediately after deletion
			const refreshEvent = new CustomEvent('contentStatusChanged', {
				detail : {
					contentId,
					newStatus   : 'deleted',
					contentType : type
				}
			});

			window.dispatchEvent(refreshEvent);
		}
		catch (error)
		{
			console.error(`Error deleting ${type}:`, error);
			toast.error(`Failed to delete ${type?.toLowerCase() || 'content'}`);
		}
		finally
		{
			setIsDeleting(false);
		}
	};

	const getPublishUnpublishLabel = () =>
	{
		if (contentStatus === 'published')
		{
			return language?.unpublish || 'Unpublish';
		}
		else
		{
			return language?.publish || 'Publish';
		}
	};

	return (
		<div>
			<Grid item onClick={(e) => { e.stopPropagation(); }}>
				<IconButton
					onClick={handleMoreClick}
					sx={{
						backgroundColor : 'white',
						'&:hover'       : {
							backgroundColor : 'white'
						},
						boxShadow : '0px 2px 4px rgba(0, 0, 0, 0.1)'
					}}
				>
					<IoMdMore fontSize='24px' color='#000' />
				</IconButton>
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleClose}
					PaperProps={{
						sx : {
							bgcolor        : 'rgba(115, 115, 115, 0.6)',
							color          : '#fff',
							backdropFilter : 'blur(2px)'
						}
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				>
					{hasPublishPermissionForType && ![ 'Playlists' ].includes(type || '') &&
						<MenuItem
							onClick={handlePublishUnpublish}
							disabled={isPublishing}
						>
							{isPublishing ? 'Processing...' : getPublishUnpublishLabel()}
						</MenuItem>
					}
					{!ContentCategoryType &&
						<MenuItem onClick={handlePreviewClick}>
							{language?.preview}
						</MenuItem>
					}
					{!ContentCategoryType && type && [ 'Playlists' ].includes(type || '') && hasPublishPermissionForType &&
					<MenuItem onClick={handleEnableDisable}>
						{contentData?.enabled ? 'Disable' : 'Enable'}
					</MenuItem>}
					{(contentData?.allowShare || (contentData?.files && contentData.files.length > 0 && contentData.files[0]?.allowShare)) &&
						<MenuItem onClick={handleCopyLinkClick}>
							{language?.copylinkTxt}
						</MenuItem>
					}
					{!ContentCategoryType && [ 'Videos' ].includes(type || '') &&
						<MenuItem onClick={handleEditContentClick}>
							{language?.addToplaylist}
						</MenuItem>
					}
					{hasWritePermission && !(type === 'Articles' && contentStatus?.toLowerCase() === 'published') &&
						<MenuItem onClick={handleEditContentClick}>
							{language?.edit}
						</MenuItem>
					}
					{hasWritePermission &&
						<MenuItem onClick={handleContentDelete}>
							{language?.delete}
						</MenuItem>
					}
				</Menu>
			</Grid>
			{showDeleteConfirm && (
				<CategoryDeletePopup
					open={showDeleteConfirm}
					handleDialogClose={() => setShowDeleteConfirm(false)}
					categoryName={`this ${type?.slice(0, -1).toLowerCase() || 'content'}`}
					isConfirmed={isConfirmed}
					handleConfirmChange={handleConfirmChange}
					isDeleting={isDeleting}
					handleDelete={handleDeleteConfirm}
				/>
			)}
		</div>
	);
};